import { useNavigate, useSearchParams } from 'react-router'
import { toast } from 'sonner'

import { AuthToastMessage } from '@/components/AuthToastMessage'
import { FeedbackModal } from '@/components/FeedbackModal/FeedbackModal'
import { SignupForm } from '@/components/signup-form'
import { Button } from '@/components/ui/button'
import { useDisclosure } from '@/hooks/use-disclosure'
import { AuthFooter, AuthLayout } from '@/layouts/AuthLayout'
import { useAuth } from '@/lib/auth'

export default function SignupPage() {
  const [searchParams] = useSearchParams()
  const ref = searchParams.get('ref')
  const email = searchParams.get('email')

  const navigate = useNavigate()
  const { isOpen: isFeedbackOpen, onToggle } = useDisclosure()

  useAuth({
    middleware: 'guest',
    tmp: 'Signup',
  })

  return (
    <AuthLayout>
      <title>Registrace</title>

      <AuthToastMessage ref={ref} />

      <SignupForm
        email={email || undefined}
        onSuccess={() => {
          toast.success('Registrace byla úspěšná', {
            description:
              'Nyní prosím potvrďte svou registraci kliknutím na odkaz v e-mailu.',
            duration: 5000,
            onDismiss: () => navigate('/auth/login'),
          })

          navigate('/auth/login')
        }}
      />

      <AuthFooter>
        <Button variant="link" size="sm" onClick={onToggle}>
          Zpětná vazba
        </Button>
        <FeedbackModal isOpen={isFeedbackOpen} onToggle={onToggle} />
      </AuthFooter>
    </AuthLayout>
  )
}
